gl-app {
  display: block;
  height: 100%;
  width: 100%;
}
gl-app .pane-main {
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: relative;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
gl-app .map-content .fixed-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
gl-app .map-content ion-fab.fab-vertical-bottom {
  bottom: 30px;
}
